import { useTranslation } from "react-i18next";
import type { ThemeClasses } from "../types";
import { TrackingReplaysViewToggle } from "./TrackingReplaysViewToggle";

interface TrackingReplaysHeaderProps {
  themeClasses: ThemeClasses;
  selectedView: "grid" | "list";
  totalItems: number;
  canCreate: boolean;
  onViewChange: (view: "grid" | "list") => void;
  onAddNew: () => void;
}

export function TrackingReplaysHeader({
  themeClasses,
  selectedView,
  totalItems,
  canCreate,
  onViewChange,
  onAddNew,
}: TrackingReplaysHeaderProps) {
  const { t } = useTranslation("adminSections");

  return (
    <div className={`${themeClasses.bg} border-b ${themeClasses.border} px-4 py-3 sm:px-6 sm:py-4`}>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4 mb-3">
        <div className="min-w-0">
          <h1 className={`text-xl sm:text-2xl font-bold ${themeClasses.text}`}>
            {t("trackingReplays.title")}
          </h1>
          <p className={`text-sm ${themeClasses.textSecondary} mt-1`}>
            {t("trackingReplays.subtitle", { count: totalItems })}
          </p>
        </div>
        <button
          onClick={onAddNew}
          disabled={!canCreate}
          title={!canCreate ? t("trackingReplays.selectCompanyFirst") : undefined}
          className={`px-3 sm:px-4 py-2 rounded-lg font-medium flex items-center justify-center space-x-2 transition-colors whitespace-nowrap text-sm sm:text-base self-start sm:self-auto flex-shrink-0 ${
            !canCreate
              ? "bg-primary-500/50 cursor-not-allowed text-gray-800"
              : "bg-primary-500 hover:bg-primary-400 text-gray-900"
          }`}
        >
          <i className="ri-add-line"></i>
          <span className="hidden sm:inline">{t("trackingReplays.addRecording")}</span>
          <span className="sm:hidden">{t("trackingReplays.addRecordingShort")}</span>
        </button>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="flex-1"></div>
        <TrackingReplaysViewToggle
          selectedView={selectedView}
          themeClasses={themeClasses}
          onViewChange={onViewChange}
        />
      </div>
    </div>
  );
}
